(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gml-price-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    function mount(root) {
      if (root.dataset.priceMounted) return;
      root.dataset.priceMounted = 'true';
      const minimum = root.querySelector('[data-price-min]');
      const maximum = root.querySelector('[data-price-max]');
      const lowSlider = root.querySelector('[data-price-range-min]');
      const highSlider = root.querySelector('[data-price-range-max]');
      const track = root.querySelector('[data-price-track]');
      const error = root.querySelector('[data-price-input-error]');
      const labels = JSON.parse(root.querySelector('[data-price-labels]').textContent);
      const currency = root.dataset.currency;
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, maximumFractionDigits: 2 });
      let ceiling = 250000;
      const groupedInteger = new Intl.NumberFormat('en-CA', { useGrouping: true, maximumFractionDigits: 0 });
      const groupedDecimal = new Intl.NumberFormat('en-CA', { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const formatField = value => (Number.isInteger(value) ? groupedInteger : groupedDecimal).format(value);
      const amount = (value, fallback) => {
        if (value === null || value === undefined) return fallback;
        const text = String(value).trim();
        if (!text) return fallback;
        if (!/^(?:(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?|\.\d{1,2})$/.test(text)) return NaN;
        return Number(text.replaceAll(',', ''));
      };
      const values = () => ({ minPrice: amount(minimum.value, 0), maxPrice: amount(maximum.value, null) });
      const validAmount = value => Number.isFinite(value) && value >= 0 && Number.isSafeInteger(Math.round(value * 100));
      function clearError() { error.hidden = true; error.textContent = ''; minimum.removeAttribute('aria-invalid'); maximum.removeAttribute('aria-invalid'); }
      function display() {
        const { minPrice, maxPrice } = values();
        const low = validAmount(minPrice) ? minPrice : 0;
        const high = maxPrice !== null && validAmount(maxPrice) ? maxPrice : null;
        ceiling = Math.max(250000, Math.ceil(Math.max(low, high || 0) / 50000) * 50000);
        lowSlider.max = highSlider.max = String(ceiling);
        lowSlider.value = String(low);
        highSlider.value = String(high === null ? ceiling : high);
        lowSlider.setAttribute('aria-valuetext', format.format(low) + ' ' + currency);
        highSlider.setAttribute('aria-valuetext', high === null ? labels.unlimited : format.format(high) + ' ' + currency);
        track.style.setProperty('--gml-price-low', (low / ceiling * 100) + '%');
        track.style.setProperty('--gml-price-high', ((high === null ? ceiling : high) / ceiling * 100) + '%');
        lowSlider.style.zIndex = low / ceiling > .85 ? '4' : '2';
        root.dataset.minPrice = String(low);
        root.dataset.maxPrice = high === null ? '' : String(high);
        root.querySelectorAll('[data-price-preset]').forEach(button => {
          const [a, b] = button.dataset.pricePreset.split(',');
          button.setAttribute('aria-pressed', String(low === Number(a) && high === amount(b, null)));
        });
      }
      function set(detail = {}) {
        const low = amount(detail.minPrice, 0);
        const high = amount(detail.maxPrice, null);
        minimum.value = validAmount(low) ? formatField(low) : '0';
        maximum.value = high !== null && validAmount(high) ? formatField(high) : '';
        clearError();
        display();
      }
      function apply() {
        clearError();
        const { minPrice, maxPrice } = values();
        const invalidLow = !validAmount(minPrice);
        const invalidHigh = maxPrice !== null && !validAmount(maxPrice);
        if (invalidLow || invalidHigh || (maxPrice !== null && minPrice > maxPrice)) {
          error.textContent = invalidLow || invalidHigh ? labels.invalid : labels.reversed;
          error.hidden = false;
          const input = invalidLow ? minimum : maximum;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        minimum.value = formatField(minPrice);
        maximum.value = maxPrice === null ? '' : formatField(maxPrice);
        display();
        root.dispatchEvent(new CustomEvent('gml:price-change', { bubbles: true, detail: { minPrice, maxPrice, currency } }));
      }
      minimum.addEventListener('input', () => { clearError(); display(); });
      maximum.addEventListener('input', () => { clearError(); display(); });
      [minimum, maximum].forEach(input => {
        input.addEventListener('blur', () => {
          const value = amount(input.value, input === minimum ? 0 : null);
          if (value === null) input.value = '';
          else if (validAmount(value)) input.value = formatField(value);
        });
        input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); apply(); } });
      });
      lowSlider.addEventListener('input', () => {
        const low = Number(lowSlider.value);
        minimum.value = formatField(low);
        const high = amount(maximum.value, null);
        if (high !== null && validAmount(high) && high < low) maximum.value = formatField(low);
        clearError(); display();
      });
      highSlider.addEventListener('input', () => {
        const high = Number(highSlider.value);
        maximum.value = high === ceiling ? '' : formatField(high);
        const low = amount(minimum.value, 0);
        if (validAmount(low) && high < low) minimum.value = formatField(high);
        clearError(); display();
      });
      let dragging = null;
      const pointerAmount = event => {
        const rect = track.getBoundingClientRect();
        const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left - 9.5) / Math.max(1, rect.width - 19)));
        return Math.round(ratio * ceiling / 1000) * 1000;
      };
      track.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        const value = pointerAmount(event);
        const low = Number(lowSlider.value);
        const high = Number(highSlider.value);
        const toLow = Math.abs(value - low);
        const toHigh = Math.abs(value - high);
        const slider = toLow < toHigh || (toLow === toHigh && value <= low) ? lowSlider : highSlider;
        dragging = { pointerId: event.pointerId, slider };
        event.preventDefault();
        slider.focus({ preventScroll: true });
        track.setPointerCapture(event.pointerId);
        slider.value = String(value);
        slider.dispatchEvent(new Event('input', { bubbles: true }));
      }, { capture: true });
      track.addEventListener('pointermove', event => {
        if (!dragging || event.pointerId !== dragging.pointerId) return;
        event.preventDefault();
        dragging.slider.value = String(pointerAmount(event));
        dragging.slider.dispatchEvent(new Event('input', { bubbles: true }));
      });
      const endDrag = event => { if (dragging?.pointerId === event.pointerId) dragging = null; };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', endDrag);
      root.querySelectorAll('[data-price-preset]').forEach(button => button.addEventListener('click', () => {
        const [low, high] = button.dataset.pricePreset.split(',');
        set({ minPrice: Number(low), maxPrice: amount(high, null) });
      }));
      root.querySelector('[data-price-apply]').addEventListener('click', apply);
      root.querySelector('[data-price-reset]').addEventListener('click', () => {
        set({ minPrice: 0, maxPrice: null });
        root.dispatchEvent(new CustomEvent('gml:price-reset', { bubbles: true, detail: { currency } }));
      });
      root.addEventListener('gml:price-sync', event => set(event.detail));
      const syncURL = () => { const params = new URLSearchParams(location.search); set({ minPrice: params.get('gml_min'), maxPrice: params.get('gml_max') }); };
      window.addEventListener('popstate', syncURL);
      syncURL();
    }
    document.querySelectorAll('[data-gml-price]').forEach(mount);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gml-price]').forEach(mount));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gml-product-related"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = (value) => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/^[\s-]+|[\s-]+$/g, '').replace(/\s+/g, ' ').toLowerCase();
  const initialize = () => document.querySelectorAll('[data-gml-related]').forEach(async (root) => {
    if (root.dataset.relatedReady) return;
    root.dataset.relatedReady = 'true';
    const vendor = normalize(root.dataset.vendor);
    const reference = normalize(root.dataset.reference);
    const model = normalize(root.dataset.model);
    const dial = normalize(root.dataset.dial);
    if (!vendor || !dial || (!reference && !model)) return;
    const url = new URL(window.GmlLocale?.url(root.dataset.searchUrl) || root.dataset.searchUrl, location.origin);
    url.searchParams.set('view', 'gml-price-data');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', 'vendor:"' + root.dataset.vendor.replace(/["\\]/g, '') + '"');
    url.searchParams.set('options[prefix]', 'none');
    const current = new URL(location.href);
    ['preview_theme_id', 'country', 'currency', 'locale'].forEach((key) => { if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key)); });
    const seenPages = new Set();
    const seenProducts = new Set();
    const matches = [];
    let next = url;
    try {
      while (next && matches.length < 4 && !seenPages.has(next.href)) {
        if (next.origin !== location.origin) return;
        seenPages.add(next.href);
        const response = await fetch(next, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        if (!Array.isArray(data.items)) return;
        for (const item of data.items) {
          const id = String(item.id || '');
          if (!id || id === root.dataset.productId || seenProducts.has(id) || !item.available || normalize(item.vendor) !== vendor) continue;
          seenProducts.add(id);
          const differentDial = normalize(item.dial) && normalize(item.dial) !== dial;
          const sameReference = reference && normalize(item.reference) === reference;
          const sameModel = model && normalize(item.model) === model;
          if (!differentDial || (!sameReference && !sameModel) || typeof item.html !== 'string') continue;
          const template = document.createElement('template');
          template.innerHTML = item.html;
          const card = template.content.querySelector('[data-product-card]');
          if (!card) continue;
          card.classList.add('revealed');
          matches.push(card);
          if (matches.length === 4) break;
        }
        next = data.nextURL ? new URL(data.nextURL, next) : null;
        if (next) {
          next = new URL(window.GmlLocale?.url(next.href) || next.href, location.origin);
          next.searchParams.set('view', 'gml-price-data');
          ['preview_theme_id', 'country', 'currency', 'locale'].forEach((key) => { if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key)); });
        }
      }
      if (!matches.length || !root.isConnected) return;
      root.querySelector('[data-gml-related-grid]').replaceChildren(...matches);
      root.hidden = false;
      window.BLANO?.bootWishlistUI?.();
      document.dispatchEvent(new CustomEvent('gml:products-rendered', { detail: { root } }));
    } catch {
      root.hidden = true;
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gml-smart-search"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.GMLSmartSearch?.version === 1) return;
  const contextKeys = ['preview_theme_id','preview_key','_fd','pb','country','currency','locale'];
  const brandAliases = {
    'cartier':['Cartier'],
    'rolex':['Rolex','RLX'],
    'vacheron-constantin':['Vacheron Constantin','Vacheron','VC'],
    'audemars-piguet':['Audemars Piguet','Audemars','AP'],
    'patek-philippe':['Patek Philippe','Patek','PP'],
    'richard-mille':['Richard Mille','RM']
  };
  const compact = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^\p{L}\p{N}]/gu,'');
  const tokens = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim().replace(/\s+/g,' ');
  const clean = value => String(value || '').trim().replace(/\s+/g,' ').slice(0,160);
  const quote = value => '"'+String(value).replace(/\\/g,'\\\\').replace(/"/g,'\\"')+'"';
  const exclusion = ' NOT product_type:"Accessories" NOT product_type:"Eyewear" NOT product_type:"Jewelry" NOT product_type:"Jewellery"';
  let cachedNode = null;
  let cachedIndex = null;
  function indexCatalogue(catalogue) {
    const brands = new Map(), models = new Map(), canonical = new Map(), prefixes = [];
    const add = (map, key, item) => {
      const normalized = compact(key);
      if (!normalized) return;
      if (!map.has(normalized)) map.set(normalized,[]);
      const entries = map.get(normalized);
      if (!entries.some(entry => entry.brand.slug === item.brand.slug && entry.model.slug === item.model.slug)) entries.push(item);
    };
    catalogue.forEach(brand => {
      const aliases = [...new Set([brand.name,brand.slug,...(brandAliases[brand.slug] || [])])];
      aliases.forEach(alias => brands.set(compact(alias),brand));
      const prefixAliases = new Set(aliases.flatMap(alias => [tokens(alias),compact(alias)]));
      prefixAliases.forEach(alias => prefixes.push({alias,brand}));
      (brand.models || []).forEach(model => {
        const item = {brand,model};
        const names = [...new Set([model.name,model.slug,...(model.aliases || [])])];
        [model.name,model.slug].forEach(name => {
          add(canonical,name,item);
          aliases.forEach(alias => {add(canonical,alias+' '+name,item);add(canonical,name+' '+alias,item);});
        });
        names.forEach(name => {
          add(models,name,item);
          aliases.forEach(alias => {add(models,alias+' '+name,item);add(models,name+' '+alias,item);});
        });
      });
    });
    prefixes.sort((a,b) => b.alias.length-a.alias.length);
    return {catalogue,brands,models,canonical,prefixes};
  }
  function getIndex() {
    const source = document.querySelector('[data-gml-catalogue]');
    if (!source) return null;
    if (source !== cachedNode) {
      try {
        const catalogue = JSON.parse(source.textContent);
        if (!Array.isArray(catalogue) || !catalogue.length) return null;
        cachedIndex = indexCatalogue(catalogue);
        cachedNode = source;
      } catch { return null; }
    }
    return cachedIndex;
  }
  function splitBrand(words,index) {
    const normalized = tokens(words);
    const rawTokens = [...words.matchAll(/[\p{L}\p{M}\p{N}]+/gu)];
    const matches = [];
    index.prefixes.forEach(({alias,brand}) => {
      const count = alias.split(' ').length;
      if (normalized.startsWith(alias+' ') && rawTokens[count-1]) {
        const last = rawTokens[count-1];
        const text = words.slice(last.index+last[0].length).replace(/^[\s,.:/-]+/,'').trim();
        if(text) matches.push({brand,text,length:alias.length});
      }
      if (normalized.endsWith(' '+alias) && rawTokens[rawTokens.length-count]) {
        const text = words.slice(0,rawTokens[rawTokens.length-count].index).replace(/[\s,.:/-]+$/,'').trim();
        if(text) matches.push({brand,text,length:alias.length});
      }
    });
    if (!matches.length || new Set(matches.map(match => match.brand.slug)).size !== 1) return null;
    return matches.sort((a,b) => b.length-a.length)[0];
  }
  function looksLikeReference(value) {
    return /^(?:[a-z]{0,3}\s*)?\d[0-9a-z./\s-]*$/i.test(value) && (value.match(/\d/g) || []).length >= 4;
  }
  function resolve(value) {
    const words = clean(value);
    const index = getIndex();
    if (!words || !index) return {kind:'text',text:words,brand:null};
    const key = compact(words);
    const brand = index.brands.get(key);
    if (brand) return {kind:'brand',brand,text:words};
    const named = index.canonical.get(key) || [];
    if (named.length === 1) return {kind:'model',...named[0],text:words};
    const aliases = index.models.get(key) || [];
    const scoped = splitBrand(words,index);
    const reference = scoped ? scoped.text : words;
    if (looksLikeReference(reference)) {
      const aliasBrands = [...new Set(aliases.map(item => item.brand.slug))];
      const refBrand = scoped?.brand || (aliasBrands.length === 1 ? aliases[0].brand : null);
      return {kind:'reference',brand:refBrand,text:reference};
    }
    if (aliases.length === 1) return {kind:'model',...aliases[0],text:words};
    return {kind:'text',brand:scoped?.brand || null,text:scoped?.text || words};
  }
  function getRoutes() {
    try { return JSON.parse(document.querySelector('[data-gml-smart-search-routes]')?.textContent || '{}'); }
    catch { return {}; }
  }
  function destination(value,form) {
    const result = resolve(value);
    const index = getIndex();
    const routes = getRoutes();
    const here = new URL(location.href);
    const fallback = form?.action || routes.search || '/search';
    const path = result.kind === 'brand' ? routes.explore || fallback : fallback;
    const url = new URL(window.GmlLocale?.url(path) || path, location.origin);
    contextKeys.forEach(key => {if(here.searchParams.has(key))url.searchParams.set(key,here.searchParams.get(key));});
    if (form?.dataset.gmlSearchPreservePrice === 'true') {
      ['gml_min','gml_max'].forEach(key => {
        const value = here.searchParams.get(key);
        if(value !== null && /^\d+(?:\.\d{1,2})?$/.test(value)) url.searchParams.set(key,value);
      });
    }
    if (result.kind === 'brand' && routes.explore) {
      url.searchParams.set('view','gml-explore');
      url.hash = result.brand.slug;
      return url;
    }
    const allBrands = index?.catalogue || [];
    const vendor = brand => 'vendor:'+quote(brand.name.toUpperCase());
    const vendorQuery = result.brand ? vendor(result.brand) : '('+allBrands.map(vendor).join(' OR ')+')';
    const baseQuery = result.kind === 'model' ? result.model.query : vendorQuery;
    const searchText = result.kind === 'model' ? '' : result.text;
    const textQuery = searchText.split(/\s+/).filter(Boolean).map(quote).join(' AND ');
    const scope = allBrands.length ? '('+baseQuery+')'+exclusion : '';
    url.searchParams.set('type','product');
    url.searchParams.set('view','gml-results');
    url.searchParams.set('gml_scope','watches');
    url.searchParams.set('options[prefix]','none');
    url.searchParams.set('q',scope+(scope && textQuery?' AND ':'')+(textQuery?'('+textQuery+')':''));
    if (result.brand) url.searchParams.set('gml_brand',result.brand.slug);
    if (result.kind === 'model') url.searchParams.set('gml_model',result.model.slug);
    if (searchText) url.searchParams.set('gml_text',searchText);
    return url;
  }
  function prefill(scope=document) {
    scope.querySelectorAll('form[data-gml-smart-search][data-gml-search-prefill]').forEach(form => {
      if(form.dataset.gmlSearchPrefilled) return;
      form.dataset.gmlSearchPrefilled = 'true';
      const input = form.querySelector('[name="q"]');
      if(!input) return;
      const params = new URLSearchParams(location.search);
      if(params.has('gml_text')) {input.value=params.get('gml_text');return;}
      const index = getIndex();
      const brand = index?.catalogue.find(item => item.slug===params.get('gml_brand'));
      const model = brand?.models.find(item => item.slug===params.get('gml_model'));
      if(model) input.value=brand.name+' '+model.name;
      else if(brand) input.value=brand.name;
      else if(params.get('gml_scope')==='watches') input.value='';
    });
  }
  window.GMLSmartSearch = Object.freeze({version:1,resolve,destination});
  document.addEventListener('submit',event => {
    const form = event.target;
    if(event.defaultPrevented || !(form instanceof HTMLFormElement) || !form.matches('[data-gml-smart-search]')) return;
    const input = form.querySelector('[name="q"]');
    const words = clean(input?.value);
    event.preventDefault();
    if(!words) {input?.focus();return;}
    input.value=words;
    const url = destination(words,form);
    const path = url.pathname+url.search+url.hash;
    location.assign(window.GmlLocale?.url(path) || path);
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>prefill(),{once:true});
  else prefill();
  document.addEventListener('shopify:section:load',event=>prefill(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gml-watch-history"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'gml_watch_history_v1';
    const preferencesAllowed = () => {
      try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
      catch { return false; }
    };
    const text = value => typeof value === 'string' ? value.trim() : '';
    const normalize = value => text(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const validURL = value => {
      if (typeof value !== 'string') return '';
      try {
        const url = new URL(value, location.origin);
        return url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname) ? url.pathname : '';
      } catch { return ''; }
    };
    const validImage = value => {
      if (!text(value)) return '';
      try {
        const url = new URL(value, location.origin);
        return url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.myshopify.com')) ? url.href : '';
      } catch { return ''; }
    };
    const readRaw = () => {
      if (!preferencesAllowed()) return [];
      const data = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(data)) throw new Error('Invalid viewing history');
      return data;
    };
    const readHistory = () => {
      const seen = new Set();
      return readRaw().filter(item => item && /^\d+$/.test(String(item.id)) && typeof item.title === 'string' && validURL(item.url) && Number.isFinite(item.viewedAt) && item.viewedAt > 0 && item.viewedAt <= 8640000000000000).sort((a, b) => b.viewedAt - a.viewedAt).filter(item => {
        if (seen.has(String(item.id))) return false;
        seen.add(String(item.id));
        return true;
      });
    };
    const recordView = () => {
      if (!preferencesAllowed()) return;
      const data = document.querySelector('[data-gml-viewed-watch]');
      if (!data) return;
      try {
        const item = JSON.parse(data.dataset.watch);
        if (!/^\d+$/.test(String(item.id)) || !validURL(item.url) || !text(item.title)) return;
        const previous = readRaw();
        const viewed = { id: String(item.id), locale: document.documentElement.lang || 'en', title: item.title, vendor: text(item.vendor), model: text(item.model), reference: text(item.reference), url: validURL(item.url), image: validImage(item.image), viewedAt: Date.now() };
        localStorage.setItem(storageKey, JSON.stringify([viewed, ...previous.filter(entry => String(entry?.id) !== viewed.id)]));
      } catch { return; }
    };
    const element = (tag, className, value) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (value !== undefined) node.textContent = value;
      return node;
    };
    const contextual = path => {
      const url = new URL(window.GmlLocale?.url(path) || path, location.origin);
      const here = new URL(location.href);
      ['preview_theme_id', 'preview_key', '_fd', 'pb', 'country', 'currency', 'locale'].forEach(key => { if (here.searchParams.has(key)) url.searchParams.set(key, here.searchParams.get(key)); });
      return url.pathname + url.search;
    };
    const initialize = () => {
      document.querySelectorAll('[data-gml-history]').forEach(root => {
        if (root.dataset.historyReady) return;
        root.dataset.historyReady = 'true';
        const lifecycle = new AbortController();
        const copy = JSON.parse(root.querySelector('[data-gml-history-copy]').textContent);
        const catalogue = JSON.parse(root.querySelector('[data-gml-catalogue]').textContent);
        const groups = root.querySelector('[data-gml-history-groups]');
        const count = root.querySelector('[data-gml-history-count]');
        const empty = root.querySelector('[data-gml-history-empty]');
        const notice = root.querySelector('[data-gml-history-notice]');
        const more = root.querySelector('[data-gml-history-more]');
        const cache = new Map();
        let shown = 12;
        let generation = 0;
        let requests;
        let entries = [];
        const countLabel = length => length === 1 ? copy.countOne : copy.count.replace('[count]', String(length));
        const family = (item, product) => {
          const vendor = normalize(product?.vendor || item.vendor);
          const brand = catalogue.find(candidate => normalize(candidate.name) === vendor || normalize(candidate.slug) === vendor);
          if (!brand) return { key: 'other', label: copy.other };
          const explicit = normalize(product?.model || item.model);
          const title = normalize(product?.title || item.title);
          const candidates = brand.models.flatMap(model => [model.name, model.slug, ...(model.aliases || [])].map(alias => ({ model, alias: normalize(alias) }))).filter(candidate => candidate.alias.length > 2).sort((a, b) => b.alias.length - a.alias.length);
          const matches = source => candidates.find(candidate => (' ' + source + ' ').includes(' ' + candidate.alias + ' '));
          const matched = matches(explicit) || matches(title);
          if (!matched) return { key: 'other', label: copy.other };
          return { key: brand.slug + '/' + matched.model.slug, label: (brand.displayName || brand.name) + ' ' + (matched.model.displayName || matched.model.name) };
        };
        const card = item => {
          const cached = cache.get(String(item.id));
          const product = cached?.product;
          const title = text(product?.title) || (item.locale === (document.documentElement.lang || 'en') ? item.title : [item.vendor, item.model, item.reference].filter(Boolean).join(' ') || copy.fallback);
          const cardNode = element('li', 'gml-history__card gml-watch-card');
          cardNode.dataset.historyId = String(item.id);
          const productURL = contextual(validURL(item.url));
          const isMissing = cached?.state === 'missing';
          const visual = element(isMissing ? 'div' : 'a', 'gml-history__visual');
          if (!isMissing) { visual.href = productURL; visual.setAttribute('aria-label', title); }
          const source = validImage(product?.featured_image || item.image);
          if (source) {
            const image = element('img');
            image.src = source; image.alt = ''; image.width = 700; image.height = 735; image.loading = 'lazy';
            image.addEventListener('error', () => image.replaceWith(element('span', 'gml-history__fallback', copy.fallback)), { once: true });
            visual.append(image);
          } else visual.append(element('span', 'gml-history__fallback', copy.fallback));
          const details = element('div', 'gml-history__details');
          details.append(element('p', 'gml-history__vendor', text(product?.vendor) || text(item.vendor)));
          const displayTitle = text(product?.card_title) || title;
          const heading = element('h3');
          if (isMissing) heading.textContent = displayTitle;
          else { const link = element('a', '', displayTitle); link.href = productURL; link.setAttribute('aria-label', title); link.title = title; heading.append(link); }
          details.append(heading);
          const reference = text(product?.reference) || text(item.reference);
          const metadata = [];
          const year = text(product?.year);
          if (reference && !displayTitle.toLowerCase().includes(reference.toLowerCase())) metadata.push(copy.reference.replace('[reference]', reference));
          if (year && !displayTitle.includes(year)) metadata.push(year);
          details.append(element('p', 'gml-history__reference', metadata.join(' · ')));
          if (product) {
            if (product.available) {
              let price = copy.onRequest;
              if (!product.inquireOnly && Number.isFinite(product.price) && product.price >= 0) {
                try { price = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: product.currency, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(product.price / 100); }
                catch { price = product.currency + ' ' + (product.price / 100).toFixed(2); }
                if (product.price_varies) price = copy.from + ' ' + price;
              }
              details.append(element('p', 'gml-history__price', price));
            } else details.append(element('p', 'gml-history__state', copy.unavailable));
          } else {
            details.append(element('p', 'gml-history__state', cached?.state === 'missing' ? copy.unlisted : cached?.state === 'error' ? copy.loadError : copy.loading));
            if (cached?.state === 'error') {
              const retry = element('button', 'gml-history__retry', copy.retry);
              retry.type = 'button'; retry.addEventListener('click', () => { cache.delete(String(item.id)); refresh(); }); details.append(retry);
            }
          }
          const time = element('time', 'gml-history__date');
          const date = new Date(item.viewedAt);
          time.dateTime = date.toISOString();
          time.textContent = copy.viewed.replace('[date]', date.toLocaleDateString(document.documentElement.lang || 'en', { month: 'short', day: 'numeric', year: 'numeric' }));
          details.append(time);
          if (!isMissing) {
            const link = element('a', 'gml-history__card-link'); link.href = productURL;
            const arrow = element('span', 'gml-css-arrow'); arrow.setAttribute('aria-hidden', 'true');
            link.append(element('span', '', copy.view), arrow); details.append(link);
          }
          cardNode.append(visual, details);
          return cardNode;
        };
        const render = () => {
          const focused = groups.contains(document.activeElement) ? document.activeElement.closest('[data-history-id]')?.dataset.historyId : '';
          const focusedClass = document.activeElement?.className || '';
          const grouped = new Map();
          entries.slice(0, shown).forEach(item => {
            const group = family(item, cache.get(String(item.id))?.product);
            if (!grouped.has(group.key)) grouped.set(group.key, { label: group.label, entries: [] });
            grouped.get(group.key).entries.push(item);
          });
          const fragment = document.createDocumentFragment();
          let index = 0;
          grouped.forEach(group => {
            const section = element('section', 'gml-history__group');
            const heading = element('div', 'gml-history__group-heading');
            const title = element('h2', '', group.label); title.id = root.getAttribute('aria-labelledby') + '-group-' + index++;
            section.setAttribute('aria-labelledby', title.id);
            heading.append(title, element('span', 'gml-history__group-count', countLabel(group.entries.length)));
            const grid = element('ul', 'gml-history__grid'); grid.setAttribute('role', 'list');
            group.entries.forEach(item => grid.append(card(item)));
            section.append(heading, grid); fragment.append(section);
          });
          groups.replaceChildren(fragment);
          count.textContent = countLabel(entries.length);
          empty.hidden = entries.length > 0;
          more.hidden = entries.length <= shown;
          if (focused) {
            const node = [...groups.querySelectorAll('[data-history-id]')].find(node => node.dataset.historyId === focused);
            const target = [...(node?.querySelectorAll('a, button') || [])].find(node => node.className === focusedClass) || node?.querySelector('a');
            target?.focus({ preventScroll: true });
          }
        };
        const refresh = async () => {
          const run = ++generation;
          requests?.abort(); requests = new AbortController();
          const signal = requests.signal;
          try { entries = readHistory(); notice.hidden = true; }
          catch { notice.hidden = false; empty.hidden = true; groups.replaceChildren(); groups.setAttribute('aria-busy', 'false'); count.textContent = ''; more.hidden = true; return; }
          render();
          const pending = entries.slice(0, shown).filter(item => !cache.has(String(item.id)));
          groups.setAttribute('aria-busy', String(pending.length > 0));
          let index = 0;
          const worker = async () => {
            while (index < pending.length && !signal.aborted && !lifecycle.signal.aborted) {
              const item = pending[index++];
              const request = new AbortController();
              const abort = () => request.abort();
              signal.addEventListener('abort', abort, { once: true });
              const timeout = setTimeout(abort, 12000);
              let value = { state: 'error', product: null };
              try {
                const url = contextual(validURL(item.url) + '?view=gml-wishlist-data');
                const response = await fetch(url, { credentials: 'same-origin', signal: request.signal, headers: { Accept: 'text/html' } });
                if (response.status === 404 || response.status === 410) value.state = 'missing';
                else if (response.ok) {
                  const product = await response.json();
                  if (String(product.id) !== String(item.id) || typeof product.available !== 'boolean' || typeof product.inquireOnly !== 'boolean' || !/^[A-Z]{3}$/.test(product.currency)) throw new Error('Invalid product details');
                  if (product.available && !product.inquireOnly && (!Number.isFinite(product.price) || product.price < 0)) throw new Error('Invalid product price');
                  value = { state: 'ready', product };
                }
              } catch { if (signal.aborted) return; }
              finally { clearTimeout(timeout); signal.removeEventListener('abort', abort); }
              if (run === generation && !lifecycle.signal.aborted) cache.set(String(item.id), value);
            }
          };
          await Promise.all(Array.from({ length: Math.min(4, pending.length) }, worker));
          if (run !== generation || lifecycle.signal.aborted) return;
          render(); groups.setAttribute('aria-busy', 'false');
        };
        more.addEventListener('click', () => {
          const next = entries[shown];
          shown += 12;
          refresh();
          if (next) [...groups.querySelectorAll('[data-history-id]')].find(node => node.dataset.historyId === String(next.id))?.querySelector('a')?.focus();
        }, { signal: lifecycle.signal });
        document.addEventListener('gml:history-change', refresh, { signal: lifecycle.signal });
        window.addEventListener('storage', event => { if (event.key === storageKey || event.key === null) refresh(); }, { signal: lifecycle.signal });
        window.addEventListener('pageshow', event => { if (event.persisted) { cache.clear(); refresh(); } }, { signal: lifecycle.signal });
        document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) { requests?.abort(); lifecycle.abort(); } }, { signal: lifecycle.signal });
        refresh();
      });
    };
    const syncConsent = () => {
      if (preferencesAllowed()) recordView();
      else if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function') {
        try { localStorage.removeItem(storageKey); } catch { /* Storage can be unavailable. */ }
      }
      document.dispatchEvent(new CustomEvent('gml:history-change'));
    };
    let privacyLoading = false;
    const loadPrivacy = () => {
      if (window.Shopify?.customerPrivacy) { syncConsent(); return; }
      if (privacyLoading || typeof window.Shopify?.loadFeatures !== 'function') return;
      privacyLoading = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
          privacyLoading = false;
          if (!error) syncConsent();
        });
      } catch { privacyLoading = false; }
    };
    const start = () => { initialize(); loadPrivacy(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    window.addEventListener('load', loadPrivacy, { once: true });
    window.addEventListener('pageshow', event => { if (event.persisted) loadPrivacy(); });
    document.addEventListener('visitorConsentCollected', syncConsent);
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

})();
